/* eslint-disable react/display-name */
import { ElementType, Suspense } from "react"

// project-imports
import PageLoader from "./PageLoader"

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: ElementType) => (props: any) => (
    <Suspense fallback={<PageLoader />}>
        <Component {...props} />
    </Suspense>
)

export default Loadable
